import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button, Typography } from "@mui/material";
import { getProfile } from "../redux/asyncThunk/userActions";
// import { getHelpMessage } from "../redux/asyncThunk/serviceActions";
// import ErrorIcon from "@mui/icons-material/Error";
import KeyAvaileble from "./KeyAvaileble";
import formatDateToDDMMYYYY from "../utils/formatDate";
import "../index.css";
import { userSlice } from "../redux/user/userSlice";

const { showDialog } = userSlice;

export default function Profile() {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user?.data);
  const profile = useSelector((state) => state.user?.profile);
  const keys = useSelector((state) => state.user?.keys);
  const games = useSelector((state) => state.user?.games);

  useEffect(() => {
    if (user?.user.id) {
      dispatch(getProfile({ id: user.user.id }));
    }
  }, [dispatch, user?.user.id]);

  let years = [];
  const getYearsList = () => {
    let currentYear = new Date().getFullYear();

    for (let i = 0; i < 100; i++) {
      const element = currentYear--;
      years.push(element);
    }
  };

  getYearsList();

  return (
    <div>
      <div
        style={{ display: "flex", justifyContent: "center", padding: "10px 0" }}
      >
        <h1>Профиль</h1>
      </div>

      <div
        style={{
          marginTop: "30px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          height: "85vh",
        }}
      >
        <div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "30px",
                padding: "10px 10px",
              }}
            >
              <div style={{ display: "flex", gap: "10px" }}>
                <div>ID аккаунта:</div>
                <div>{user?.user?.id}</div>
              </div>
              <div style={{ display: "flex", gap: "10px" }}>
                <div>Электронная почта:</div>
                <div>{user?.user?.login}</div>
                {profile?.email?.confirm ? (
                  <Typography
                    size="small"
                    id="outlined-basic"
                    label="Почта"
                    variant="outlined"
                  >
                    {user?.email?.confirm}
                  </Typography>
                ) : null}
              </div>
              {/* <div>
                <div style={{ display: "flex", gap: "5px", alignItems: "center" }}>
                  <div>Привязать аккаунт к телеграм аккаунту</div>
                  {!profile?.tgId?.id ? (
                    <Tooltip
                      title="Нажмите для получения подсказки"
                      placement="top"
                    >
                      <ErrorIcon
                        onClick={() =>
                          dispatch(getHelpMessage({ key: "linkToTGaccaunt" }))
                        }
                        sx={{ cursor: "pointer", fontSize: "14px", color: "red" }}
                      />
                    </Tooltip>
                  ) : null}
                </div>
                {!profile?.tgId?.id ? (
                  <div
                    style={{
                      marginTop: "20px",
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <Box>
                      <Typography>{profile?.tgId?.confirmCode}</Typography>
                    </Box>
                    <Button
                      size="small"
                      variant="contained"
                      onClick={() => {
                        dispatch(
                          confirmTG({
                            id: user.id,
                            onSuccess: () => dispatch(getProfile({ id: user.id })),
                          })
                        );
                      }}
                    >
                      Сгенерировать код
                    </Button>
                  </div>
                ) : (
                  <Box>
                    <Typography>{profile?.tgId?.id}</Typography>
                  </Box>
                )}
              </div> */}
            </div>
            <div>
              <KeyAvaileble limit={profile?.limit} />
            </div>
          </div>
          <div style={{ padding: "20px 20px" }}>
            <div>Ключи по всем сценариям</div>

            <ul>
              <div
                style={{
                  display: "flex",
                  gap: "3px",
                  backgroundColor: "#b6c3cf",
                  maxWidth: "1400px",
                  width: "100%",
                  justifyContent: "space-between",
                  height: "40px",
                  alignItems: "center",
                }}
              >
                <div style={{ width: "300px", textAlign: "center" }}>
                  Проект
                </div>
                <div style={{ width: "500px", textAlign: "center" }}>Ключ</div>
                <div style={{ width: "200px", textAlign: "center" }}>
                  Использован
                </div>
                <div style={{ width: "400px", textAlign: "center" }}>
                  Дата использования
                </div>
              </div>
              {keys?.map((el) => {
                const getTitle = games?.find((elem) => el.game === elem._id);

                return (
                  <li
                    style={{
                      display: "flex",
                      padding: "5px 0",
                      borderBottom: "1px solid rgb(182, 195, 207)",
                      borderLeft: "1px solid rgb(182, 195, 207)",
                      borderRight: "1px solid rgb(182, 195, 207)",
                      maxWidth: "1400px",
                      width: "100%",
                    }}
                    key={el.key}
                  >
                    <div style={{ width: "300px", textAlign: "center" }}>
                      {getTitle?.title}
                    </div>
                    <div style={{ width: "500px", textAlign: "center" }}>
                      {el.key}
                    </div>
                    <div style={{ width: "200px", textAlign: "center" }}>
                      {el.availeble ? "Нет" : "Да"}
                    </div>
                    <div style={{ width: "400px", textAlign: "center" }}>
                      {el.usageDate
                        ? formatDateToDDMMYYYY(el?.usageDate)
                        : "Не использован"}
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>

        <div style={{ display: "flex", paddingLeft: "10px" }}>
          <Button
            color="error"
            size="small"
            variant="contained"
            onClick={() => dispatch(showDialog("delete-accaunt"))}
          >
            Удалить аккаунт
          </Button>
        </div>
      </div>
    </div>
  );
}
